import { render, staticRenderFns } from "./CotProductsTab.vue?vue&type=template&id=a0d8e98a&scoped=true"
import script from "./CotProductsTab.vue?vue&type=script&lang=js"
export * from "./CotProductsTab.vue?vue&type=script&lang=js"
import style0 from "./CotProductsTab.vue?vue&type=style&index=0&id=a0d8e98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d8e98a",
  null
  
)

export default component.exports